import { TextCodes } from '@api/types/translation/TextCodes';
import styled from '@emotion/styled';
import { useAppDispatch, useAppSelector } from '@hooks';
import { Close } from '@mui/icons-material';
import { Box, Button, Drawer } from '@mui/material';
import { getModalState, setModalState } from '@store/modal/modal.slice';
import { spacing } from '@themes/theme.helpers';
import { t } from '@translations';
import { ReactNode } from 'react';

export type SearchFilterDrawerProps = {
  modalId: string;
  children?: ReactNode;
};

const DrawerContent = styled(Box)`
  min-width: 250px;
  position: relative;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const DrawerFooter = styled(Box)`
  text-align: center;
`;

const DrawerHeader = styled(Box)`
  width: 100%;
  text-align: right;
  padding: ${spacing(2)};
  cursor: pointer;
`;

export const SearchFilterDrawer = ({ modalId, children }: SearchFilterDrawerProps) => {
  const modalState = useAppSelector(getModalState(modalId));
  const dispatch = useAppDispatch();
  const closeHandler = () => dispatch(setModalState({ id: modalId, isVisible: false }));
  return (
    <Drawer variant='temporary' open={modalState.isVisible} onClose={closeHandler}>
      <DrawerContent>
        <DrawerHeader onClick={closeHandler}>
          <Close sx={{ fontSize: 30 }} />
        </DrawerHeader>
        {children}
        <DrawerFooter>
          <Button onClick={closeHandler}>{t(TextCodes.Base.Close)}</Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
